import { render, staticRenderFns } from "./HandleTax.vue?vue&type=template&id=6f3feb15"
import script from "./HandleTax.vue?vue&type=script&lang=js"
export * from "./HandleTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports